import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomTabLoginComponent} from './custom-tab-login.component';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from "@spartacus/core";
import {RouterModule} from "@angular/router";


@NgModule({
  declarations: [CustomTabLoginComponent],
  exports: [
    CustomTabLoginComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        TabLoginComponent: {
          component: CustomTabLoginComponent,
        },
      },
    } as CmsConfig),
    RouterModule,
    UrlModule,
    I18nModule,
  ]
})
export class CustomTabLoginModule {
}
